import { Injectable, InjectionToken, Optional, Inject } from '@angular/core';

/**
 * Configuration options for modal sizing.
 */
export interface ModalConfig {
  width?: number;               // width in px, default 600
  height?: number | 'auto';     // height in px, 'auto' for content-fit, default uses 80vh
  fullScreenOnMobile?: boolean; // if true (default), modal is full-screen on mobile; if false, uses width/height
}

/**
 * Injection token for modal configuration (used internally by ModalPageMarker).
 */
export const MODAL_CONFIG = new InjectionToken<ModalConfig>('ModalConfig');

/**
 * Marker class to indicate a page is a modal page.
 * Modal pages are displayed as popovers on larger screens.
 *
 * Usage: Modal pages provide this in their @Component decorator:
 *   providers: [ModalPageMarker]
 *
 * For custom sizing:
 *   providers: [{ provide: ModalPageMarker, useValue: new ModalPageMarker({ width: 480 }) }]
 *
 * Child components can then inject it to check if they're in a modal:
 *   constructor(@Optional() private modalMarker: ModalPageMarker) {}
 *   // if modalMarker is not null, we're in a modal page
 */
@Injectable()
export class ModalPageMarker {
  readonly config: ModalConfig;

  constructor(@Optional() @Inject(MODAL_CONFIG) config?: ModalConfig | null) {
    this.config = config || {};
  }
}
